import React, { Component } from 'react';
import _ from 'lodash';

import { Settings as SettingsIcon } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
    createStyles,
    Menu,
    MenuItem,
    Typography
} from '@material-ui/core';


import { MyPATPopMenu, MenuData } from '../../common';

const styles = createStyles({

});

interface ContentTopMenuProps extends WithStyles<typeof styles> {
    
}
interface ContentTopMenuState {
}

class ContentTopMenu extends Component<ContentTopMenuProps, ContentTopMenuState>{
    menuItems: MenuData[] = [{
        type: 'redirect',
        id: 1,
        to: "/tag-management?course",
        img: "/assets/img/mylibrary/settingsMenu/tag-icon.png",
        text: "Tag Management"
    },{
        type: 'redirect',
        id: 2,
        to: "/goal-management?course",
        img: "/assets/img/course/goalManage.png",
        text: "Goal Management"
    },{
        type: 'redirect',
        id: 3,
        to: "/course/coursetemplate",
        img: "/assets/img/mylibrary/settingsMenu/template-icon.png",
        text: "Course Templates"
    }];

    constructor(props: ContentTopMenuProps, state: ContentTopMenuState) {
		super(props);
	}
	render() {

		return ( <MyPATPopMenu id="settings-menu" icon={SettingsIcon} menuItem={this.menuItems} />
    );
	}
}

// @ts-ignore
export default withStyles(styles)(ContentTopMenu);